<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-10-12 18:25:30
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-26 14:13:05
-->
<template>
  <div class="container" id="container-map">
        <div class="mapBox">
            <baidu-map :style="{'height': mapHeight}" class="map" :center="center" :scroll-wheel-zoom="true" :zoom="zoom" @ready="handler">
                <bm-marker :position="{lng: point.lng, lat: point.lat}" name=""></bm-marker>
            </baidu-map>
        </div>
        <div class="bottom-box animate__animated animate__fadeInUp">
            <div class="piont-left"></div>
            <div class="piont-right"></div>
            <div class="title">{{$t('contact.company')}}</div>
            <div class="height25"></div>
            <div style="font-family: 'Lato','Microsoft JhengHei';'">{{$t('contact.address')}}</div>
            <div style="height:15px"></div>
            <div class="font18"><img src="../../assets/images/youbian.png">{{$t('contact.post')}}</div>
            <div class="font18"><img src="../../assets/images/chuanzhen.png">{{$t('contact.fax')}}</div>
            <div class="font18"><img src="../../assets/images/phone.svg">{{$t('contact.phone')}}</div>
            <div class="font18"><img src="../../assets/images/phone.svg">{{$t('contact.service_phone')}}</div>
            <div class="font18"><img src="../../assets/images/url.png">{{$t('contact.url')}}</div>
        </div>
  </div>
</template>
<script>
export default({
    mounted() {
        this.mapHeight = document.getElementById("container-map").offsetHeight / 2 + 'px'
    },
    data() {
        return{
            center: {lng: 0, lat: 0},
            zoom: 3,
            point: {
                lng: 121.613934,
                lat: 31.1725
            },
            mapHeight: '337px'
        }
    },
    methods: {
        handler ({BMap, map}) {
            this.center.lng = 121.613934
            this.center.lat = 31.172406
            this.zoom = 17
        }
    },
})
</script>

<style scoped>
    .mapBox{
        width: 100%;
    }
    .piont-left{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        left: -15px;
        border-radius: 50%;
    }
    .piont-right{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
    }
    .bottom-box{
        height: 100%;
        padding: 67px 49px;
        background: #F8F8F8;
        color: #4C4948;
    }
    .title{
        color: #ED6D00;
        /* font-family: 'Lato-Bold'; */
        font-family: 'Lato','Microsoft JhengHei';
    }
    .height25{
        height: 25px;
    }
    .font18{
        font-size: 18px;
        padding-bottom: 3px;
        font-family: 'Lato','Microsoft JhengHei';
    }
    .font18 img{
        vertical-align: middle;
        position: relative;
        bottom: 2px;
        margin-right: 10px;
        width: 18px;
    }
</style>


// WEBPACK FOOTER //
// src/components/contactUs/contactUs.vue